export default {
  lastSearchString: "",
};
